import { ReactElement, useRef } from 'react';
import { AnswerSource } from 'src/redux/survey/survey.types';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';

interface NormalizationToggleProps {
  isNormalized: boolean;
  onToggle: (isNormalized: boolean) => void;
  answerFilter: AnswerSource;
}

const SLIDER_COLORS: Record<AnswerSource, string> = {
  [AnswerSource.All]: '#3358fc',
  [AnswerSource.AI]: 'rgba(117, 35, 241, 1)',
  [AnswerSource.Human]: 'rgba(255, 109, 45, 1)',
  [AnswerSource.RTR]: '#3358fc',
};

const NUM_PCT = 1/2;
const PCT_PCT = 1/2;

const NormalizationToggle = ({ isNormalized, onToggle, answerFilter }: NormalizationToggleProps): ReactElement => {
  const thumbRef = useRef<HTMLDivElement | null>(null);
  const color = SLIDER_COLORS[answerFilter] || '#3358fc';
  const containerWidth = 96;
  const numWidth = containerWidth * NUM_PCT;
  const pctWidth = containerWidth * PCT_PCT;
  const padding = 4;

  useGSAP(() => {
    const width = isNormalized ? pctWidth - 2 * padding : numWidth - 2 * padding;
    const left = isNormalized ? numWidth + padding : padding;
    gsap.to(thumbRef.current, {
      backgroundColor: color,
      width: width,
      left: left,
      duration: 0.25,
    });
  }, [isNormalized, answerFilter, numWidth, pctWidth]);

  return (
    <div className="relative flex w-24 h-10 items-center bg-white/20 rounded-full select-none">
      {/* Sliding thumb */}
      <div
        ref={thumbRef}
        className="absolute top-1 h-8 rounded-full z-0 transition-colors"
        style={{ pointerEvents: 'none', left: padding, width: numWidth - 2 * padding }}
      />
      {/* Options */}
      <div className="relative flex w-full h-full z-10">
        <button
          className={`flex items-center justify-center font-medium text-xs transition-colors rounded-full h-full ${!isNormalized ? 'text-white' : 'text-gray-300'}`}
          style={{ flexBasis: `${NUM_PCT * 100}%`, zIndex: 1 }}
          onClick={() => onToggle(false)}
          type="button"
        >
          123
        </button>
        <button
          className={`flex items-center justify-center font-medium text-xs transition-colors rounded-full h-full ${isNormalized ? 'text-white' : 'text-gray-300'}`}
          style={{ flexBasis: `${PCT_PCT * 100}%`, zIndex: 1 }}
          onClick={() => onToggle(true)}
          type="button"
        >
          %
        </button>
      </div>
    </div>
  );
};

export default NormalizationToggle;